import React from 'react';
import Competitor from 'components/presentation/Competitor';
import Organisation from 'components/presentation/Organisation';
import { NocMemo as Noc } from 'components/presentation/Noc';
import Label from "components/general/Label"
import Movement from "components/presentation/Movement"
import { findArray, isParalympic, CompetitionFromStore, RscFromStore, getEntityLessThanTen, getEntityMoreThanOrEqualTen } from 'helpers/utils'
import SportCode from 'components/common/SportCode'
import { useViewport } from 'components/general/useViewPort';
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { getDisciplineRSC } from 'helpers/rsc';
import { getAge } from "helpers/utils";
import RecordIndicator from 'components/general/RecordIndicator';
import SvgMirs from 'components/presentation/SvgMirs';



export const CellRank = React.memo(({ node, hasRankEqual }) => {
    let photo = node?.extendedResults ? node?.extendedResults.filter(row => (row?.er_code === 'PHOTO' && row?.er_value === 'P')).map((val) => { return (val?.er_value) }) : ''
    let rank = node?.resultType !== 'IRM'
        ? node?.resultIrm !== 'OTL'
            ? node?.resultRank
            : ''
        : '|REL|OVL|OTL|'.includes(node?.resultIrm) ? node?.resultRank : ''

    rank = rank ? rank : '' //remove undefined
    let resp = (photo && photo.length) > 0
        ? <SvgMirs className='mirsIcon' title="LabelPhotoFinish" code='camera' />
        : (hasRankEqual && node?.resultRankEqual === 'Y') ? `=${rank}` : rank
    return (resp)
}
);

export const CellDiff = React.memo(({ node }) => {
    let diff = node?.diff && node?.resultType !== 'IRM' && node?.resultIrm !== 'REL' && node?.resultIrm !== 'OTL'
        ? node?.diff
        : node?.resultIrm === 'REL' || node?.resultIrm === 'OTL'
            ? <SportCode entity='@IRM' code={node?.resultIrm} abbr={true} />
            : ''
    return (diff)
}
);

export const CellDiffOws = React.memo(({ node }) => {
    let diff = node?.diff && node?.resultType !== 'IRM' && node?.resultIrm !== 'REL' && node?.resultIrm !== 'OTL'
        ? node?.diff
        : ''
    return (diff)
}
);

export const CellResult = React.memo(({ irm }) => {
    return (irm)
});

//Added Lane Infringement
export const CellCardsFalseStart = React.memo(({ extendedResults, participant }) => {
    const { mirs_discipline } = useUrlFriendlyToParameters()
    const { breakPoint } = useViewport();
    let cards = extendedResults.filter(row => row.er_code === 'YC' || row.er_code === 'RC' || row.er_code === 'YRC' || row.er_code === 'PENALTY' || (row.er_type === 'ER' && row.er_code === 'UNDER_PROTEST' && row.er_value === 'P')).map((val, key) => {
        let penalty;
        if (val.er_code === 'PENALTY') {
            penalty = val.er_value === 'Y'
                ? <SvgMirs key={participant + '_Card_Y_FS' + key} className='mirsIcon' title='LabelYellowCard' code='yellow-card' />
                : <SvgMirs key={participant + '_Card_R_FS' + key} className='mirsIcon' title='LabelRedCard' code='red-card' />
        } else if (val.er_code === 'YC') {
            penalty = <SvgMirs key={participant + '_Card_YC_FS' + key} className='mirsIcon' title='LabelYellowCard' code='yellow-card' />;
        } else if (val.er_code === 'RC') {
            penalty = <SvgMirs key={participant + '_Card_RC_FS' + key} className='mirsIcon' title='LabelRedCard' code='red-card' />;
        } else if (val.er_code === 'YRC') {
            penalty = <SvgMirs key={participant + '_Card_YRC_FS' + key} className='mirsIcon' title='LabelYellowCards' code='double_yellow' />;
        } else if (val.er_code === 'UNDER_PROTEST' && mirs_discipline === 'ATH') {
            penalty = <>
                <SvgMirs key={participant + '_Card_U_FS' + key} className='mirsIcon' title={<SportCode discipline={mirs_discipline} titleIsText={true} entity='@Card' code={'P'} />} code='protest' />
                <span className='d-none'><SportCode discipline={mirs_discipline} entity='@Card' code={'P'} abbr={true} /></span>
            </>;
        }
        return penalty;
    })

    let falseStarts = extendedResults.filter(row => row.er_code === 'FALSE_START').map((val, key) => {
        let value2 = val.er_value2 ? '(' + val.er_value2 + ')' : "";
        let out;
        if ((mirs_discipline === 'ATH') && (breakPoint === "sm" || breakPoint === "xs")) {
            out = <div key={participant + '_FalseStart_' + key}>
                {val.er_value}
                <span className='d-none'><SportCode discipline={mirs_discipline} entity='@Card' code={'Fn'} abbr={true} /></span>
            </div>
        } else {
            out = <div key={participant + '_FalseStart_' + key}>
                {val.er_value}{value2}
                <span className='d-none'><SportCode discipline={mirs_discipline} entity='@Card' code={'Fn'} abbr={true} /></span>
            </div>
        }
        return out;
    })

    let laneInfrigement = extendedResults.filter(row => row.er_code === 'LANE_INFRINGE').map((val, key) => {
        return (<div key={participant + '_LaneInfringe_' + key}><SportCode discipline={mirs_discipline} entity='@Card' code={val.er_value} abbr={true} /> </div>)
    })

    let resp = (cards.length > 0 || falseStarts.length > 0 || laneInfrigement.length > 0) ? <>{cards}  {falseStarts} {laneInfrigement}</> : ''
    return (resp)
});

export function ColumnKeyIndex() {
    return (
        {
            Header: 'index',
            accessor: 'keyIndex',
            id: 'KeyIndex',
            disableSortBy: true,
            className: 'd-none',
            headerClassName: 'd-none'
        }
    )
}

export function ColumnStartOrder({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-5',
    label = 'LabelStartOrder',
    accessor = 'startSortOrder',
    remove = false,
    enableRowSpan = false,
    rowSpanType = 'rowid',
    type = ''

}) {
    return (
        {
            Header: <Label data={label} legendFixed={true} />,
            accessor: accessor,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'StartOrder',
            remove: remove,
            enableRowSpan: enableRowSpan,
            rowSpanType: rowSpanType,
            // Cell: (props) => (

            //     props.cell.row.original.startOrder
            // )
            Cell: (props) => {
                let row = props.cell.row.original
                switch (type) {
                    case 'laneIrm':
                        if (row?.resultType !== 'IRM') {
                            return row?.startOrder
                        } else if (row?.resultType === 'IRM') {
                            return <span className='fw-bold'><SportCode entity='@IRM' code={row?.resultIrm} abbr={true} />&nbsp;{row?.startOrder}</span>
                        }

                        break;
                    case '10m':
                        return row?.eventUnitEntries && row?.eventUnitEntries?.find(i => i?.eue_code === 'START_POS')?.eue_value
                    default:
                        return props.cell.row.original.startOrder
                }


            }
        }
    )
}

export function ColumnStartTime({
    disableSort = false,
    className = 'text-center',
    headerClassName = 'text-center w-10',
    label = 'HeaderStartTime',
}) {
    return (
        {
            Header: <Label data={label} legendFixed={true} />,
            accessor: (props) => (
                props.eventUnitEntries
                    ? props.eventUnitEntries.find(row => row.eue_code === 'START_TIME')?.eue_value
                    : ''
            ),
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'StartTime',
            Cell: (props) => (
                props.cell.row.original.eventUnitEntries
                    ? props.cell.row.original.eventUnitEntries.find(row => row.eue_code === 'START_TIME')?.eue_value
                    : ''
            )
        }
    )
}

export function ColumnRank({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-5',
    label = 'HeaderRank',
    remove = false,
    hasRankEqual = false,
    type = '',
    enableRowSpan = false,
    rowSpanType = 'rowid',

}) {

    return (
        {
            Header: <Label data={label} legendFixed={true} />,
            accessor: 'sortOrder',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Rank',
            remove: remove,
            enableRowSpan: enableRowSpan,
            rowSpanType: rowSpanType,
            Cell: (props) => {
                const { mirs_discipline } = useUrlFriendlyToParameters()

                let out;

                switch (type) {
                    case 'rankOrIrm':

                        let row = props.cell.row.original
                        let rank = row?.resultType !== 'IRM'
                            ? hasRankEqual ? <CellRank node={props.cell.row.original} hasRankEqual={hasRankEqual} /> : row?.resultRank
                            : <span className='fw-bold'><SportCode entity='@IRM' code={row?.resultIrm} abbr={true} /></span >

                        out = rank
                        break;
                    case 'rank&DNS':
                        //shows rank when result is DNS
                        let rows = props.cell.row.original
                        let rankDns
                        if ('|BMF|'.includes(mirs_discipline)) {
                            rankDns = (((rows?.resultType !== 'IRM' || rows?.resultIrm === "DNS") && rows?.resultRank) || rows?.resultType === 'IRM' && rows?.resultIrm)
                        }
                        else {
                            rankDns = (rows?.resultType !== 'IRM' || rows?.resultIrm === "DNS") && rows?.resultRank
                        }
                        out = rankDns
                        break;
                    case 'rank&RAL':
                        //shows rank when result is RAL
                        let rowRal = props.cell.row.original
                        let rankRal = (rowRal?.resultType !== 'IRM' || rowRal?.resultIrm === "RAL") && rowRal?.resultRank


                        out = rankRal
                        break;
                    case 'noRankEqual':
                        out = <CellRank node={props.cell.row.original}></CellRank>
                        break;
                    default:
                        //Si mandas todas las propiedades de la fila como esta cambia hace que se repinte 
                        out = <CellRank node={props.cell.row.original} hasRankEqual={hasRankEqual}></CellRank>

                }
                return (out)

            }
        }

    )
}

export function ColumnRankNoResult({
    disableSort = false,
    className = 'text-end fw-bold',
    headerClassName = 'text-end w-5 text-nowrap',
    label = 'HeaderRank',
    isEventRanking = false,
    isPoolStandings = false
}) {
    return (
        {
            Header: <Label data={label} legendFixed={true} />,
            accessor: 'sortOrder',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'RankNoResult',
            Cell: (props) => {
                const { mirs_discipline } = useUrlFriendlyToParameters()
                let row = props.cell.row.original
                let rank = row?.resultType !== 'IRM' ? row?.rank : ''
                let irm_rank = row?.resultType === 'IRM_RANK'
                if (isEventRanking) {
                    let irm = row?.rk_IRM ? <SportCode entity='@IRM' code={row?.rk_IRM} abbr={true} /> : <></>
                    rank = row?.rk_IRM && !irm_rank ? irm : row?.rank;
                    //Event Ranking case when you have irm and rank and want display rank
                    if (['BDM', 'FEN', 'CSL'].includes(mirs_discipline)) {
                        if (row?.rank && row?.rk_IRM) {
                            rank = row?.rank
                        }
                    }
                } else if (isPoolStandings && ['WPO', 'FBB', 'FBL', 'BKB', 'HBL', 'BKG', 'BDM', 'VBS', 'WRU', 'VVO', 'RU7'].includes(mirs_discipline)) {
                    let irm = row?.irm ? <SportCode entity='@IRM' mirs_discipline={mirs_discipline} code={row?.irm} abbr={true} /> : <></>
                    rank = row?.irm ? irm : row?.rank;
                }
                return rank
            }
        }
    )
}

export function ColumnRankNoType({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-5 text-nowrap',
    label = 'HeaderRank'
}) {

    return (
        {
            Header: <Label data={label} legendFixed={true} />,
            accessor: 'sortOrder',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'RankNoType',
            Cell: (props) => {
                return props.cell.row.original.resultRank
            }
        }
    )
}

export function ColumnBibStatus({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-5 text-nowrap',
    label = 'HeaderBib',
    expecialCase = false,
    remove = false,
    accessor = "bib"
}) {
    return (
        {
            Header: <Label data={label} legendFixed={true} />,
            accessor: accessor,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Bib',
            remove: remove,
            Cell: (props) => {
                const row = props.cell.row.original
                const playerStatus = row?.eventUnitEntries?.find(e => e?.eue_code === 'STATUS')?.eue_value;
                const bib = (expecialCase && row.bib > 99999) ? '' : row.bib
                return playerStatus ? <SportCode entity='@AthleteStatus' code={playerStatus} abbr={true} /> : bib
            }
        }
    )
}

export function ColumnBib({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-5',
    label = 'HeaderBib',
    expecialCase = false,
    remove = false,
    accessor = "bib",
    enableRowSpan = false,
    rowSpanType = 'rowid'
}) {
    return (
        {
            Header: <Label data={label} legendFixed={true} />,
            accessor: accessor,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Bib',
            remove: remove,
            enableRowSpan: enableRowSpan,
            rowSpanType: rowSpanType,
            Cell: (props) => {
                const { mirs_discipline } = useUrlFriendlyToParameters()
                let suspendedCode = props.cell.row.original?.eventUnitEntries?.find(eue => eue.eue_code === 'STATUS')?.eue_value;
                if (mirs_discipline === 'BK3' && suspendedCode) {
                    const title = Label({ data: "LabelSuspendedDesc", noHtml: true })
                    return <div><abbr title={title}><Label data="LabelSuspended" /></abbr></div>
                }
                const row = props.cell.row.original
                const bib = Number(row?.bib) === 0 ? '' : row?.bib
                return (expecialCase && row.bib > 99999) ? '' : bib
            }
        }
    )
}

export function ColumnBibStartSortOrder({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-5',
    label = 'HeaderBib',
    expecialCase = false,
    remove = false,
    accessor = 'startSortOrder',
    enableRowSpan = false,
    rowSpanType = 'rowid'
}) {
    return (
        {
            Header: <Label data={label} legendFixed={true} />,
            accessor: accessor,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'BibStartSortOrder',
            remove: remove,
            enableRowSpan: enableRowSpan,
            rowSpanType: rowSpanType,
            Cell: (props) => {
                const row = props.cell.row.original
                const bib = Number(row?.bib) === 0 ? '' : row?.bib
                return (expecialCase && row.bib > 99999) ? '' : bib
            }
        }
    )
}
export function ColumnIrmRanking({
    disableSort = false,
    className = 'text-start',
    headerClassName = 'text-end w-5',
    remove = false,
    enableRowSpan = false,
    rowSpanType = 'rowid'
}) {
    return (
        {
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Irm',
            remove: remove,
            enableRowSpan: enableRowSpan,
            rowSpanType: rowSpanType,
            accessor: (props) => {
                const irm = props.rk_IRM;
                const rank = props.rank;
                const irmLabel = irm ? <SportCode entity='@IRM' code={irm} abbr={true} /> : ''
                if (rank !== undefined && irm !== undefined) {
                    return (irmLabel)
                }
                else return ('')
            }
        }
    )
}

export function ColumnSortOrder({
    disableSort = false,
    className = 'd-none d-sm-table-cell ',
    headerClassName = 'd-none d-sm-table-cell w-5',
    label = 'HeaderSortOrder'
}) {
    return (
        {
            Header: <Label data={label} legendFixed={true} />,
            accessor: 'sortOrder',
            disableSortBy: disableSort,
            className: className,
            headerClassName: headerClassName,
            id: 'SortOrder',
        }
    )

}

export function ColumnNoc({
    disableSort = false,
    className = 'text-start d-none d-md-table-cell ',
    headerClassName = 'text-start d-none d-md-table-cell w-5 align-middle',
    label = 'HeaderNOC',
    remove = false,
    longDesc = false,
    enableRowSpan = false,
    rowSpanType = 'rowid'
}) {
    const rsc = RscFromStore();
    const discipline = getDisciplineRSC(rsc);

    const competition = CompetitionFromStore();
    if (isParalympic(competition) && label === 'HeaderNOC') {
        label = 'HeaderNPC';
    }

    if (isParalympic(competition) && label === 'HeaderCountryNOC') {
        label = 'HeaderCountryNPC';
    }
    return (
        {
            Header: <Label data={label} legendFixed={true} />,
            id: 'NOC',
            //accessor: 'participant.organisation.code',
            //Workaround when sort by noc and has rowspan
            accessor: (row) => {
                let out

                if (row?.participant?.code && 'GLF'.includes(discipline)) {
                    out = row?.participant?.organisationId + '-' + row?.participant?.code
                }
                else if (row?.participant?.code) {
                    out = row?.participant?.organisation?.code + '-' + row?.participant?.code
                }
                else {
                    out = row?.participant?.organisation?.code
                }
                return (out);
            },


            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            remove: remove,
            enableRowSpan: enableRowSpan,
            rowSpanType: rowSpanType,
            Cell: (props) => {
                const row = props.cell.row.original
                let data
                if (row?.athletes) {
                    data = row?.athletes?.find(x => x !== undefined)?.participant?.organisation
                    data = data ? data : row?.participant?.organisation  //added for cases when there is atheltes but no participant node
                    data = data ? data : { code: row?.participant?.organisationId }               //using organisationId
                } else if (row?.participant?.organisationId) {
                    data = { code: row?.participant?.organisationId }
                } else {
                    data = row?.participant?.organisation
                }
                return (<Noc {...data} showLongDesc={longDesc} />)
            }
        }
    )

}
export function ColumnAge({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderAge'
}) {
    return (
        {
            Header: <Label data={label} legendFixed={true} />,
            accessor: 'disciplineClass.classCode',
            id: 'Age',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            Cell: (props) => {
                let row = props.cell.row.original
                let age = row?.athlete ? getAge(row?.athlete.birthDate) : ''

                return age
            }
        }
    )
}

export function ColumnName({
    disableSort = false,
    className = 'text-start',
    headerClassName = 'text-start',
    label = '-',
    hideNoc = false,
    noLink = false,
    showGuide = false,
    showSeed = false,
    remove = false,
    enableRowSpan = false,
    rowSpanType = 'rowid',
    medicalClass = true,
    useTeamAthletes = false, //name displayed in 2 rows
    unchecked = false
}) {


    return (
        {
            Header: (props) => {
                const row = props?.data[0]

                let lbl
                if (label !== '-') {
                    lbl = label
                } else if (row?.participant?.code?.includes('ROW')) {
                    lbl = 'HeaderName'
                } else if (row?.participant?.code?.includes('GRY')) {
                    lbl = row?.participant?.__typename === 'Person' ? 'HeaderName' : 'LabelGroup'
                } else {
                    lbl = row?.participant?.__typename === 'Person' ? 'HeaderName' : 'HeaderTeam'
                }

                return (
                    <Label data={lbl} />
                )
            },
            accessor: (props) => (props?.participant?.name?.toUpperCase()),
            id: 'Name',
            enableRowSpan: enableRowSpan,
            rowSpanType: rowSpanType,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            hideNoc: hideNoc,
            noLink: noLink,
            showGuide: showGuide,
            showSeed: showSeed,
            remove: remove,
            unchecked: unchecked,
            Cell: (props) => {
                const { mirs_discipline } = useUrlFriendlyToParameters()
                const row = props.cell.row.original
                let data;
                let guide;
                let seed;
                if (row?.athletes) {
                    data = row?.athletes?.find(x => x !== undefined)?.participant // revisar si es necesario o ya no se usa?
                    data = data ? data : row?.participant                         //Added for cases when there is athletes but no participant node
                }
                else if (useTeamAthletes) {
                    data = row
                }
                else {
                    data = row?.participant
                }

                if (row?.guide) {
                    guide = row?.guide
                }

                seed = row?.description?.extendedDescription?.find(item => item.code === "SEED" && item.type === "ED")?.value

                let competitorPlace;
                const rowUnchecked = row.unchecked

                competitorPlace = row?.team_code ? row?.team_code : row?.athlete_code
                if (mirs_discipline === 'SRF' && row?.athleteCode === 'NOCOMP')
                    return <SportCode discipline={mirs_discipline} entity='@CompetitorPlace' code={row?.athleteCode} />
                return (
                    <>
                        {(competitorPlace?.includes('NOAWARD'))
                            ? <SportCode discipline={mirs_discipline} entity='@CompetitorPlace' code={competitorPlace} />
                            :
                            <>{useTeamAthletes ?
                                <Competitor
                                    hidePicture={true}
                                    hideNoc={hideNoc}
                                    showSeed={showSeed} // used in Pool Standings
                                    seed={seed}
                                    nolink={noLink}
                                    organisation={row?.participant?.organisation}
                                    {...data}
                                    guide={guide}
                                    showGuide={showGuide}
                                    medicalClass={medicalClass && row?.disciplineClass || data?.medicalClass ? row?.disciplineClass || data?.medicalClass : ''}
                                />
                                : !row.participant && mirs_discipline === 'TKW' ?
                                    <SportCode discipline={mirs_discipline} entity='@CompetitorPlace' code={competitorPlace} />
                                    : <Competitor
                                        hidePicture={true}
                                        hideNoc={hideNoc}
                                        showSeed={showSeed}
                                        seed={seed}
                                        nolink={noLink}
                                        {...data}
                                        guide={guide}
                                        showGuide={showGuide}
                                        unchecked={unchecked && rowUnchecked}
                                        medicalClass={medicalClass && row?.disciplineClass || data?.medicalClass ? row?.disciplineClass || data?.medicalClass : ''}
                                    />}
                            </>}
                    </>
                )
            }
        }
    )
}

export function ColumnNameH2H({
    disableSort = true,
    className = 'text-start',
    headerClassName = 'text-start',
    label = 'HeaderName',
    showCaptain = false,
    showDisciplineClass = true,
    showSuspendedCode = false,
    showStarter = false,
    hideNoc = false,
    remove = false
}) {
    return (
        {
            Header: <Label data={label} legendFixed={true} />,
            accessor: 'athlete.familyName',
            id: 'Name',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            showCaptain: showCaptain,
            showSuspendedCode: showSuspendedCode,
            showStarter: showStarter,
            hideNoc: hideNoc,
            remove: remove,
            Cell: (props) => {
                return (
                    props.cell.row.original.title ? props.cell.row.original.title
                        :
                        <>
                            <Competitor
                                {...props.cell.row.original?.athlete}
                                //{...props.cell.row.original}

                                eventUnitEntries={props.cell.row.original?.eventUnitEntries}
                                hidePicture={true}
                                showCaptain={showCaptain}
                                medicalClass={showDisciplineClass ? props.cell.row.original?.medicalClass : ''}
                                showSuspendedCode={showSuspendedCode}
                                showStarter={showStarter}
                                hideNoc={hideNoc}
                            />
                        </>
                );
            }
        }
    )
}

export function ColumnTeamAthletes({
    className = 'text-start',
    headerClassName = 'text-start',
    label = 'HeaderTeam'
}) {
    return (
        {
            Header: <Label data={label} legendFixed={true} />,
            accessor: props => props?.participant?.name.toUpperCase(),
            id: 'TeamAthletes',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: true, //habilita poder ordenar
            Cell: props => {
                const row = props.cell.row.original
                const teamAthletes = row?.teamAthletes?.sort((a, b) => a.order - b.order).map(item => (
                    <div key={item?.participant?.code} >
                        <Competitor hidePicture={true} hideNoc={false} {...item?.participant} />
                    </div>
                ))
                return <>{teamAthletes}</>
            }
        }
    )
}


export function ColumnTeamComponents({
    disableSort = false,
    className = 'text-start team-duet-container ',
    headerClassName = 'text-start',
    label = 'HeaderName',
    hideNoc = false
}) {
    return (
        {
            Header: (props) => {
                const row = props?.data[0]

                let lbl
                if (label !== 'HeaderName') {
                    lbl = label
                } else {
                    lbl = row?.participant?.__typename === 'Person' ? 'HeaderName' : 'HeaderTeam'
                }
                return (
                    <Label data={lbl} />
                )
            },
            accessor: (props) => (props?.participant?.name.toUpperCase()),
            id: 'TeamComponents',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            hideNoc: hideNoc,
            Cell: (props) => {
                const row = props.cell.row.original
                return (
                    <Competitor hidePicture={true} hideNoc={hideNoc} {...row} />
                )
            }
        }
    )
}

export function ColumnTeamOrDuetsComponents({
    disableSort = false,
    className = 'text-start team-duet-container',
    headerClassName = 'text-start',
    label = 'HeaderDuet',
    hideNoc = false,
    isTeam = true
}) {
    if (isTeam) {
        label = 'HeaderTeam'
    }
    return (
        {
            Header: <Label data={label} legendFixed={true} />,
            accessor: (props) => (props?.participant?.name.toUpperCase()),
            id: 'Name',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            hideNoc: hideNoc,
            Cell: (props) => {
                const row = props.cell.row.original
                let teamOrDuet;
                if (isTeam) {
                    teamOrDuet = row?.participant
                } else {
                    teamOrDuet = row
                }
                return (
                    <Competitor hidePicture={true} hideNoc={hideNoc} {...teamOrDuet} />
                )
            }
        }
    )
}

export function ColumnOrganisation({

    disableSort = false,
    className = 'text-start ',
    headerClassName = 'text-start  w-5',
    label = 'Organization',
    remove = false,
    onlyShortName = false
}) {
    return (
        {
            Header: <Label data={label} legendFixed={true} />,
            id: 'Organisation',
            accessor: 'participant.organisation.code',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            remove: remove,
            Cell: (props) => {
                const row = props.cell.row.original
                let data = row?.organisation
                return (<Organisation onlyShortName={onlyShortName} {...data} />)
            }
        }
    )

}



export function ColumnWarnings({
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = '',
    remove = false
}) {
    return (
        {
            remove: remove,
            Header: (label === '') ? '' : <Label data={label} />,
            className: className,
            headerClassName: headerClassName,
            accessor: 'sortOrder',
            id: 'Warnings',
            Cell: (props) => {
                const row = props.cell.row.original;
                return (
                    row?.extendedResults && row?.participant?.code
                        ? <CellCardsFalseStart extendedResults={row?.extendedResults} participant={row?.participant?.code}></CellCardsFalseStart>
                        : ''
                )
            }
        }
    )
}

export function ColumnResult({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderResult',
    remove = false,
    hideIrm = false,
    boldIrm = false,
    enableRowSpan = false,
    rowSpanType = 'rowid'
}) {

    return (
        {
            Header: <Label data={label} legendFixed={true} />,
            accessor: (props) => { return props.sortOrder },
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            id: 'Result',
            remove: remove,
            enableRowSpan: enableRowSpan,
            rowSpanType: rowSpanType,

            Cell: (props) => {
                const { mirs_discipline } = useUrlFriendlyToParameters()
                const row = props.cell.row.original
                const rowNumberIrm = findArray(row.extendedResults, { er_code: ['IRM_LAP'] })
                const numberIrm = rowNumberIrm?.er_value || ''
                const resultIrm = (row?.resultType === 'IRM' && row?.resultIrm)
                const inquiry = (mirs_discipline === 'GAR' || mirs_discipline === 'GRY') && row?.extendedResults?.find(er => er?.er_type === 'ER' && er?.er_code === 'INQUIRY')?.er_value === 'SUBMITTED' ? '*' : ''

                const resurf = mirs_discipline === 'SRF' && props.cell.row.original?.extendedResults?.find(i => i?.er_code === 'RESURF')?.er_value === 'Y'
                if (resurf) return <><Label data='LegendResurf' showAlways={true} abbrValue='*' />{props.cell.row.original.resultData}</>
                let irmObject = {}
                switch (resultIrm) {
                    case 'DNF':
                        irmObject = <><SportCode entity='@IRM' code={resultIrm} abbr={true} />{numberIrm}</>
                        break;
                    case 'LAP':
                        irmObject = <>-{numberIrm}<SportCode entity='@IRM' code={resultIrm} abbr={true} /></>
                        break;
                    default:
                        irmObject = <SportCode entity='@IRM' code={resultIrm} abbr={true} related={resultIrm} />
                        break;
                }
                irmObject = hideIrm ? <></> : boldIrm ? <span className='fw-bold'>{irmObject}</span> : irmObject;
                return (
                    (row.resultType === 'IRM' || resultIrm) || (resultIrm === 'LAP' && mirs_discipline === 'MTB')
                        ? <span className='fw-bold'>{irmObject}</span>
                        : row.resultType === 'TIME' && row.unchecked === 'Y'
                            ? mirs_discipline === 'CSL' && row.unchecked === 'Y' && row.resultData
                                ? '*' + row.resultData
                                : mirs_discipline === 'TRI'
                                    ? row.resultData
                                    : `(${row.resultData})`
                            : <>{inquiry}{row.resultData}</>
                )
            },
        }
    )
}

export function ColumnDifference({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderTimeBehind'
}) {
    return (
        {
            Header: <Label data={label} legendFixed={true} />,
            accessor: 'diff',// accessor is the "key" in the data 
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Diff',
            Cell: (props) => (
                //Si mandas todas las propiedades de la fila como esta cambia hace que se repinte 
                <CellDiff node={props.cell.row.original} ></CellDiff>

            )
        }
    )
}

export function ColumnPoints({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderPoints'
}) {
    return (
        {
            Header: <Label data={label} legendFixed={true} />,
            accessor: 'SortOrder',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            id: 'Points',
            Cell: (props) => {
                let extendedResult = findArray(props.cell.row.original.extendedResults, { er_code: ['PTS'] });
                if (extendedResult) {
                    return (extendedResult.er_value)
                }
            }
        }
    )
}

export function ColumnRecords({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-5 align-middle',
    remove = false,
    label = '',
    eventRsc = undefined
}) {
    return (
        {
            //Header: 'Ghost',
            Header: <Label data={label} legendFixed={true} />,
            remove: remove,
            accessor: 'recordIndicators',// accessor is the "key" in the data 
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            id: 'Records',
            Cell: props => {
                const row = props.cell.row.original;
                return <RecordIndicator records={row?.recordIndicators} eventRsc={eventRsc} />
            }
        }
    )
}


export function ColumnQualification({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-5',
    remove = false,
    enableRowSpan = false,
    rowSpanType = 'rowid',
    entity = '@QualificationMark',
    isSFNL
}) {
    return (
        {
            remove: remove,
            accessor: 'qualificationMark',// accessor is the "key" in the data 
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'QualMark',
            enableRowSpan: enableRowSpan,
            rowSpanType: rowSpanType,
            isSFNL: isSFNL,
            Cell: props => {
                const rsc = RscFromStore();
                const discipline = getDisciplineRSC(rsc);
                const row = props.row.original
                if (row?.qualificationMark) {
                    if (discipline === 'DIV') {
                        if (row?.qualificationMark === 'Q')
                            return (<b><SportCode entity={entity} abbr={true} code={row?.qualificationMark} /></b>)
                        else
                            return (<SportCode entity={entity} abbr={true} code={row?.qualificationMark} />)
                    }
                    if (discipline === 'SAL' && isSFNL) {
                        const qualificationMarkFinal = row?.extendedResults?.find(e => e.er_code === "SFNL")?.extensions?.find(e => e.ere_code === "QUALIFICATION")?.ere_value
                        return (<SportCode entity={entity} abbr={true} code={qualificationMarkFinal} />)
                    }
                    return (<SportCode entity={entity} abbr={true} code={row?.qualificationMark} />)
                }
            }
        }
    )
}

export function ColumnMove({
    disableSort = true,
    className = 'text-center',
    headerClassName = 'text-center w-5',
    type = '',
    remove = false,
}) {
    return (
        {
            Header: () => (<>
                <SvgMirs className='mirsIcon' title='LabelMoveUp' code='arrow-up' />
                <SvgMirs className='mirsIcon' title='LabelMoveDown' code='arrow-down' />
            </>),
            accessor: (props) => {
                let currentSplit = props.currentSplit === '999' ? props.finalSplit : props.currentSplit
                let value = '';
                let out = '';
                switch (type) {
                    case 'extendedResults':
                        value = findArray(props?.extendedResults, { er_code: ['INTERMEDIATE'], er_pos: [currentSplit] })
                        out = value.er_move
                        break;
                    case 'extendedResultsSAL':
                        value = findArray(props?.extendedResults, { er_code: ['MARK'], er_pos: [props?.moveMark] })
                        out = value.er_move
                        break;
                    case 'cumulativeResults':
                        value = findArray(props?.extendedResults, { er_code: ['MOVEMENT'] })
                        out = value.er_value
                        break;
                    default:
                        value = findArray(props?.resultAnalysis?.extendedResults, { er_code: ['INTERMEDIATE'], er_pos: [currentSplit] })
                        out = value.er_move
                        break;
                }
                //if (type === 'extendedResults') {
                //    value = findArray(props?.extendedResults, { er_code: ['INTERMEDIATE'], er_pos: [currentSplit] })
                //} else {
                //    value = findArray(props?.resultAnalysis?.extendedResults, { er_code: ['INTERMEDIATE'], er_pos: [currentSplit] })
                //}
                return (out)
            },
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Move',
            remove: remove,
            Cell: (props) => (
                <Movement move={props.value} />
            )
        }
    )
}

export function ColumnExpander({
    className = 'text-center',
    headerClassName = 'text-center expander  w-5',
    type = '',
    idNode = '',
    erCode = 'INTERMEDIATE',
    expandIrm = false,
    allExpanded = true,
    remove = false,
    isPoolStandings = false,
    sportEntryCodes,
    disc = ''
}) {

    return (
        {
            Header: ({ getToggleAllRowsExpandedProps, isAllRowsExpanded, expandedAllElements }) => (
                allExpanded && <button {...getToggleAllRowsExpandedProps()} className="button-expanded" aria-expanded="false" aria-label={Label({ data: "HeaderShowAllDetails", noHtml: true  })} >
                    {expandedAllElements ? (
                        <span className="mirsIconOpen" ></span>
                    ) : (
                        <span className="mirsIconClose" ></span>
                    )}
                </button>
            ),
            id: "Expander",
            className: className,
            headerClassName: headerClassName,
            disableSortBy: true,
            remove: remove,
            accessor: (data) => {
                //this data is added manually in this rows after read query 
                let rsc = RscFromStore();
                let discipline = getDisciplineRSC(rsc);
                let sw = false;
                let isIrm = data?.resultType?.includes("IRM");
                let category = data?.person?.mainFunction?.category;
                const person = data?.person ? data?.person : data;
                const eventEntries = person?.registeredEvents?.at(0)?.eventEntries;
                const eventEntrieslength = eventEntries?.length;
                switch (type) {
                    case 'EventUnitEntryPtsBefore':
                        if (data?.eventUnitEntries?.find(row => row.eue_code === 'PTS_BEFORE')?.eue_value !== undefined || (data.extendedResults && data.extendedResults.length > 0)) {
                            sw = true
                        }
                        break;
                    case 'onlyExtendedResults':
                        if (data.extendedResults && data.extendedResults.length > 0) {
                            sw = true
                        }
                        break;
                    case 'extendedResults':
                        if ((data.extendedResults && data.extendedResults.length > 0)
                            && (data.extendedResults.filter(row => row.er_code === erCode).length > 0)
                            && (data.resultType !== 'IRM' || (data.resultType === 'IRM' && expandIrm) || data.resultIrm === 'DNF' || data.resultIrm === 'DSQ')
                        ) {
                            sw = true
                        }
                        break;
                    case 'alwaysTrue': // no se mostraria con DQB
                        if (data.resultType !== 'IRM'
                            || (data.resultType === 'IRM' && expandIrm)
                            || data.resultIrm === 'DNF'
                            || (data.resultIrm === 'WD' && ['DIV'].includes(discipline))
                            || (data.resultIrm === 'OTL' && ['OWS'].includes(discipline))
                            || data.resultIrm === 'DSQ'
                            || data.resultIrm === 'DNS') {

                            sw = true;
                        }

                        if (data.resultIrm === 'DSQ' && (['GTR', 'GAR', 'GRY', 'GLF', 'SHO'].includes(discipline))) sw = false
                        if (data.resultIrm === 'DNS' && (['GTR', 'OWS', 'SHO'].includes(discipline))) sw = false
                        if (data?.cumData?.resultIrm === 'DQB' && (['SWA'].includes(discipline))) sw = false

                        break;
                    case 'neverIrm':
                        if (!data.resultType?.includes('IRM')) {
                            sw = true;
                        }
                        break;
                    case 'neverIrm2':
                        if (data.resultIrm === undefined) {
                            sw = true;
                        }
                        break;
                    case 'alwaysTrueTri': // no se mostraria con DNS y DQB
                        if (data.resultType !== 'IRM'
                            || (data.resultType === 'IRM' && expandIrm)
                            || data.resultIrm === 'DNF'
                            || (data.resultIrm === 'WD' && ['DIV', 'GLF'].includes(discipline))
                            || data.resultIrm === 'DSQ'
                            || data.resultIrm === 'LAP') {
                            sw = true;
                        }
                        else {
                            sw = false;
                        }
                        break;
                    case 'alwaysTrue2':
                        if (!isIrm
                            || (isIrm && (data.rk_IRM === 'DQB' || data.irm === 'WD') && isPoolStandings && !['WPO'].includes(discipline))
                        ) {
                            sw = true;
                        }
                        break;
                    case 'alwaysTrue3':
                        if (!isIrm
                            || (isIrm && (data.rk_IRM === 'DNS' || data.rk_IRM === 'DSQ' || (data.rk_IRM === 'WD' && ['DIV'].includes(discipline))))
                        ) {
                            sw = true;
                        }
                        break;
                    case 'resultAnalysis':

                        if ((data.resultAnalysis && data.resultAnalysis.extendedResults.length > 0)
                            && (data.resultAnalysis.extendedResults.filter(row => row.er_code === erCode).length > 0)
                            && (data.resultType !== 'IRM' || (data.resultType === 'IRM' && expandIrm) || data.resultIrm === 'DNF' || data.resultIrm === 'DSQ' || (data.resultIrm === 'DQ' && ['ATH'].includes(discipline)))
                        ) {
                            sw = true
                        }
                        break;
                    case 'eventRanking':

                        if (/BDM.+/.test(rsc) && data.rk_IRM) sw = true
                        if ((data.rk_IRM !== 'DSQ' && data.athlete_code !== 'NOAWARD' && data.team_code !== 'NOAWARD')
                            || /GRY.5AA-.+/.test(rsc)
                            || (data.rk_IRM !== 'DQB' && /GRY.+/.test(rsc))
                            || (data.rk_IRM !== 'DQB' && /DIV.+/.test(rsc))
                            || (data.rk_IRM !== 'DQB' && /SKB.+/.test(rsc))
                        ) {
                            sw = true;
                        }
                        if (/SHO.+/.test(rsc) && data.rk_IRM) sw = false
                        if ((data.rk_IRM === 'DQB' && /BMF.+/.test(rsc))) sw = false
                        if ((data.rk_IRM === 'DQB' && /HBL.+/.test(rsc))) sw = false
                        if ((data.rk_IRM === 'DQB' && /ARC.+/.test(rsc))) sw = false
                        if ((data.rk_IRM === 'DQB' && /VBS.+/.test(rsc))) sw = false
                        if ((data.rk_IRM === 'DQB' && /BKB.+/.test(rsc))) sw = false
                        if ((data.rk_IRM === 'DQB' && /WRE.+/.test(rsc))) sw = false
                        if (data.rk_IRM === 'DQB' && (['SKB', 'VVO'].includes(discipline))) sw = false
                        if (data.rk_IRM === 'DQB' && disc === 'WPO') sw = false
                        if ((data.rk_IRM === 'DSQ' && /ARC.+/.test(rsc))) sw = true    //ARC needs to show in DSQ
                        if (['CTR'].includes(discipline)) {
                            if ((['DNF', 'DNS', 'DQB', 'DSQ', 'WDR'].includes(data.rk_IRM))) {
                                sw = false
                            } else {
                                sw = true
                            }
                        }
                        break;
                    case 'esl':
                        if (data.extCompetitor) {
                            sw = true;
                        }
                        break;
                    case 'participant':
                        if (data.participant) {
                            sw = true;
                        }
                        break;
                    case 'IndividualAlwaysTrue': // no se mostraria con DQB
                        const createMappedEntries = (eventEntries1, sportEntryCodes1) => {
                            return eventEntries1?.map(eve => {
                                const evntEntryinSportEntry = sportEntryCodes1?.find(spEntry => spEntry?.sportCode === eve?.ee_code);
                                return { ...eve, order: evntEntryinSportEntry?.order };
                            })?.filter(f => {
                                return f?.order >= 0
                            });
                        };
                        const mappedEntries = createMappedEntries(eventEntries, sportEntryCodes);
                        const filterdMore = getEntityMoreThanOrEqualTen(mappedEntries);
                        sw = filterdMore?.length > 0 ? true : false;
                        break;
                    case 'TeamAlwaysTrue':
                        if (category === 'A' && eventEntrieslength > sportEntryCodes?.length) {
                            sw = true;
                        }
                        break;
                    case 'eslExtendedResults': // for tableExpanded with Esl and Extended results
                        if (((data.extendedResults && data.extendedResults.length > 0)
                            && (data.extendedResults.filter(row => row.er_code === erCode).length > 0)
                            && (data.resultType !== 'IRM' || (data.resultType === 'IRM' && expandIrm) || data.resultIrm === 'DNF' || data.resultIrm === 'DSQ')
                        ) || (data.extCompetitor)
                        ) {
                            sw = true;
                        }
                        break;
                    case 'eslResultAnalysis': // for tableExpanded with Esl and Extended results analysis
                        if (((data.resultAnalysis && data.resultAnalysis.extendedResults.length > 0)
                            && (data.resultAnalysis.extendedResults.filter(row => row.er_code === erCode).length > 0)
                            && (data.resultType !== 'IRM' || (data.resultType === 'IRM' && expandIrm) || data.resultIrm === 'DNF' || data.resultIrm === 'DSQ')
                        ) || (data.extCompetitor)
                        ) {
                            sw = true;
                        }
                        break;
                    default:
                        sw = true;
                        break;
                }


                let spanId = idNode === 'athlete' ? data?.athlete?.code : idNode === 'teamEntry' ? data?.person?.code : idNode ? data[idNode] : data?.participant?.code
                spanId = spanId ? spanId : data.sortOrder
                return ({
                    rowSpanId: spanId,
                    rowCanExpand: sw
                    /*
                                            (type === 'extendedResults')
                                                ? d.extendedResults && d.extendedResults.length > 0
                                                    ? d.extendedResults.filter(row => row.er_code === erCode).length > 0 ? true : false
                                                    : false
                                                : (type === 'alwaysTrue')
                                                    ? true
                                                    : (d.resultAnalysis && d.resultAnalysis.extendedResults && d.resultAnalysis.extendedResults.length > 0
                                                        ? (d.resultAnalysis.extendedResults.filter(row => row.er_code === erCode).length > 0 ? true : false)
                                                        : false)
                                    */
                })

            },
            Cell: (props) => {
                const data = props.cell.row.original
                let relAriaLabel =
                    idNode === 'athlete'
                        ? data?.athlete?.name
                        : idNode === 'teamEntry'
                            ? data?.person?.name
                            : idNode ? data["name"]
                                : data?.participant?.name
                /* relAriaLabel used in the aria-label which will be the athlete name or team name depending on the idNode. Other data["name"] get data["name"], without idNode gets participant.name */
                return props?.value?.rowCanExpand ? (
                    <button className="button-expanded" aria-expanded="false" aria-label={Label({ data: "HeaderShowDetailsOf", noHtml: true }) + ` ${relAriaLabel}`}   >
                        {props.row.isExpanded ? (
                            <span className="mirsIconOpen" ></span>
                        ) : (
                            <span className="mirsIconClose" ></span>
                        )}
                    </button>
                ) : (<span></span>)
            }
        }
    )
}

export function ColumnCompensation({
    disableSort = true,
    className = 'text-center',
    headerClassName = 'text-end w-10',
    label = 'HeaderCompensationTime'
}) {
    return (
        {
            Header: <Label data={label} legendFixed={true} />,
            accessor: 'SortOrder',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Compensation',
            Cell: (props) => {
                let extendedResult = findArray(props.cell.row.original.extendedResults, { er_code: ['COMPENSATION'] });
                if (extendedResult) {
                    return (extendedResult.er_value)
                }
            }
        }
    )
}

export function ColumnPty({
    disableSort = true,
    className = 'text-right',
    headerClassName = 'text-right w-10',
    label = 'HeaderPty',
    accessor = 'pty'
}) {
    return (
        {
            Header: <Label data={label} legendFixed={true} />,
            accessor: accessor,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Pty',
            Cell: (props) => {
                return props.cell.row.original.pty
            }
        }
    )
}

///TEST
export function ColumnEventUnitEntries({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderEventUnitEntries',
    code = ""
}) {
    return (
        {
            Header: <Label data={label} legendFixed={true} />,
            accessor: 'eventUnitEntries',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: code,
            Cell: (props) => (
                props.cell.row.original.eventUnitEntries
                    ? props.cell.row.original.eventUnitEntries.filter(row => row.eue_code === code).map((val) => { return (val.eue_value) })
                    : ''
            )
        }
    )
}

export function ColumnIrmOrValue({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-5',
    label = 'HeaderPTS',
    id = 'result',
    isPoolStandings = false,
    remove = false
}) {
    return (
        {
            Header: <Label data={label} legendFixed={true} />,
            accessor: 'eventUnitEntries',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: id,
            remove: remove,
            Cell: (props) => {
                const { mirs_discipline } = useUrlFriendlyToParameters()
                const row = props.cell.row.original
                let result = '';
                const irmValue = row?.irm || row?.resultIrm;
                if (isPoolStandings && '|WPO|'.includes(mirs_discipline) && row?.resultType === 'IRM') {
                    result = ''
                } else if (row[id] !== undefined && '|SAL|'.includes(mirs_discipline) && !row?.resultType) {
                    result = '';
                } else if (row?.resultType === 'IRM_POINTS') {
                    if ('|WPO|'.includes(mirs_discipline)) {
                        result = ''
                    } else {
                        result = (<>
                            <div className='tex-end'>
                                {row?.resultData}
                            </div>
                            <div className='tex-end'>
                                <SportCode discipline={mirs_discipline} entity='@IRM' code={irmValue} abbr={true} />
                            </div>
                        </>);
                    }
                } else if (row?.resultType === 'IRM' && irmValue !== undefined) {
                    result = <SportCode discipline={mirs_discipline} entity='@IRM' code={irmValue} abbr={true} />;
                } else if (row[id] !== undefined) {
                    result = row[id];
                }
                return (
                    result
                )
            }
        }
    )
}

export function ColumnRankOws({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-5 text-nowrap',
    label = 'HeaderRank'
}) {
    return (
        {
            Header: <Label data={label} legendFixed={true} />,
            accessor: 'rank',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Rank',
            Cell: (props) => {
                let row = props.cell.row.original
                return (
                    (row.resultType !== 'IRM' && row.resultIrm !== 'REL' && row.resultIrm !== 'OTL')
                        ? <CellRank node={props.cell.row.original} ></CellRank>
                        : row.resultType === 'REL' || row.resultType === 'IRM_TIME' || row.resultType === 'IRM'
                            ? row?.resultIrm
                            : ''
                )
            },
        }
    )
}

export function ColumnResultOWS({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderResult'
}) {
    return (
        {
            Header: <Label data={label} legendFixed={true} />,
            accessor: 'SortOrder',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            id: 'Result',

            Cell: (props) => {
                return (
                    (props.cell.row.original.resultType !== 'IRM')
                        ? props.cell.row.original.resultData
                        : ''
                )
            }
        }
    )
}

export function ColumnDifferenceOws({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderTimeBehind'
}) {
    return (
        {
            Header: <Label data={label} legendFixed={true} />,
            accessor: 'diff',// accessor is the "key" in the data 
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Diff',
            Cell: (props) => {
                let row = props.cell.row.original
                return (
                    (row.resultType !== 'IRM' && row.resultIrm !== 'REL' && row.resultIrm !== 'IRM_TIME')
                        ? <CellDiffOws node={props.cell.row.original} ></CellDiffOws>
                        : ''
                )
            },
        }
    )
}

export function ColumnSportClass({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderMedical'
}) {
    return (
        {
            Header: <Label data={label} legendFixed={true} />,
            accessor: 'disciplineClass.classCode',
            id: 'SportClass',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            Cell: (props) => {
                let row = props.cell.row.original
                let medicalClass = row?.medicalClass

                return medicalClass && <abbr title={medicalClass?.description}>{medicalClass?.classCode}</abbr>
            }
        }
    )
}

export function ColumnGender({
    disableSort = true,
    className = 'text-start',
    headerClassName = 'text-start w-10',
    label = 'HeaderGender'
}) {
    return (
        {
            Header: <Label data={label} legendFixed={true} />,
            accessor: 'athlete.personGender.code',
            id: 'Gender',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            Cell: (props) => {
                let row = props.cell.row.original
                let gender = row?.athlete?.personGender

                return gender && <abbr title={gender?.description}>{gender?.code}</abbr>
            }
        }
    )
}

export function ColumnHorse({
    disableSort = false,
    className = 'text-start',
    headerClassName = 'text-start',
    label = 'HeaderHorse',
    remove = false
}) {
    return (
        {
            Header: <Label data={label} legendFixed={true} />,
            accessor: (props) => (props?.horse?.name?.toUpperCase()),
            id: 'Horse',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            remove: remove,
            Cell: (props) => {
                const row = props.cell.row.original;
                return (<Competitor {...row?.horse} __typename="Horse" hideNoc={true} hidePicture={true} />);
            }
        }
    )
}


export function ColumnAthleteHorse({
    disableSort = false,
    className = 'text-start',
    headerClassName = 'text-start',
    label = 'HeaderAthleteHorse',
    remove = false
}) {
    return (
        {
            Header: <Label data={label} legendFixed={true} />,
            accessor: (props) => (props?.participant?.name?.toUpperCase()),
            id: 'AthleteHorse',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            remove: remove,
            Cell: (props) => {
                const row = props.cell.row.original;
                return (
                    <>
                        <Competitor hidePicture={true} hideNoc={false} nolink={false}  {...row?.participant} />
                        <Competitor {...row?.horse} __typename="Horse" shortName={row?.horse?.name} hideNoc={true} hidePicture={true} />
                    </>
                );
            }
        }
    )
}

export function ColumnExtendedResult({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-5',
    label = 'HeaderNone',
    remove = false,
    id = 'er',
    code = '',
    type = 'ER',
    dataSource = 'er_value'
}) {
    return (
        {
            Header: <Label data={label} legendFixed={true} />,
            accessor: (props) => {
                const er = props?.extendedResults?.find(er => er?.er_code === code && er?.er_type === type);
                return er ? er[dataSource] : '';
            },
            id: id,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            remove: remove,
            Cell: (props) => {
                const row = props.cell.row.original;
                const er = row?.extendedResults?.find(er => er?.er_code === code && er?.er_type === type);
                return er ? er[dataSource] : '';
            }
        }
    )
}


export function ColumnPosition({
    disableSort = true,
    className = 'text-start',
    headerClassName = 'text-start w-10',
    label = 'HeaderPosition',
    code = 'Position'
}) {

    return (
        {
            Header: <Label data={label} legendFixed={true} />,
            accessor: 'functionDescription',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: code,
            Cell: (props) => {
                const { breakPoint } = useViewport();
                let position = (breakPoint === "sm" || breakPoint === "xs") ? props.cell.row.original.functionCode : props.cell.row.original.functionDescription
                return (position)
            }
        }
    )
}
